import GlobalButton from 'Components/common/components/GlobalButton';
import { selectAiCertificationData } from 'Selector/CertificationSelector';
import { selectNextUploadDocuments, selectUploadCancelled, selectUploadLink } from 'Selector/DocumentHubSelector';
import { actions } from 'Slice/DocumentHubSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { LINK_REGEX, SMART_REDIRECTION_TEXT } from 'Utils/Constants';
import { getTimezoneInGMT, valueToObject } from 'Utils/UtilityFunctions';
import {
  inputGlobal, primaryColor, secondaryFont, wMBold,
} from 'Utils/utilsStyle';
import { Input } from 'antd';
import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { chatStates } from 'Components/layout/headers/NavBarPrimary';
import { FileWithId } from 'Types/DocumentHubTypes';

const Wrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
padding: 12px 16px;
.add-link-text {
  font-family: ${secondaryFont};
  font-size: 20px;
  font-weight: ${wMBold};
  line-height: 22px;
  letter-spacing: -0.532px;
  color: #444B4F;
  margin-bottom: 4px;
}
.input-for-add-link {
  ${inputGlobal};
  margin-bottom: 8px;
}
.add-link-cls{
  width: fit-content;
  align-self: flex-end;
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
  }
}
`;

const AddLinkComponent = function AddLinkComponent() {
  const dispatch = useDispatch();
  const { saveProfileName: saveProfileNameV2 } = chatStates;
  const timezone = getTimezoneInGMT();
  const uploadLink = useSelector(selectUploadLink);
  const uploadCancelled = useSelector(selectUploadCancelled);
  const nextUploadDocuments = useSelector(selectNextUploadDocuments);
  const [input, setInput] = useState<string>('');
  const aiCertificationData = useSelector(selectAiCertificationData);
  const host = window.location.href;

  const redirectFrom = () => {
    if (saveProfileNameV2 && !saveProfileNameV2.includes(SMART_REDIRECTION_TEXT)) {
      return 'gilroy';
    }
    if (saveProfileNameV2?.includes(SMART_REDIRECTION_TEXT)) {
      return 'accountPlan';
    }
    return 'docHub';
  };
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value);
  };

  const isInputValidated = () => {
    const trimmedInput = input.trim();
    return trimmedInput.length > 5 && !trimmedInput.includes(' ')
      && LINK_REGEX.test(trimmedInput);
  };

  const handleButtonClick = () => {
    if (!uploadCancelled) {
      dispatch(actions.resetBatch());
    }
    if (uploadCancelled) {
      dispatch(actions.setNextUploadDocument({ name: 'Preparing for upload ...', type: 'unknown' } as FileWithId));
    } else {
      dispatch(actions.setUploadLink(input.trim()));
      dispatch(actions.setUploadDocument({ name: 'Preparing for upload ...', type: 'unknown' } as FileWithId));
    }
    dispatch(certificationActions.aiCertificationAction({
      type: 'add_file_document',
      source: 'doc_gilroy',
      data: aiCertificationData,
    }));
    dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_link_upload_confirm', 0, {
      redirection_from: redirectFrom(),
      host,
    })));
  };

  useEffect(() => () => {
    setInput('');
  }, []);

  useEffect(() => {
    if (uploadLink.length) {
      setTimeout(() => {
        setInput('');
        dispatch(actions.setBatchSize(1));
        dispatch(actions.modifyUploadDocument({ name: 'Link uploading...', type: 'link' } as FileWithId));
        // dispatch(actions.uploadDocument({
        //   fileUrl: uploadLink,
        //   timezone,
        // }));
      }, 1000);
    }
  }, [uploadLink]);

  useEffect(() => {
    if (!uploadCancelled && nextUploadDocuments.length) {
      dispatch(actions.resetNextUploadDocuments());
      dispatch(actions.setUploadLink(input.trim()));
      dispatch(actions.setUploadDocument({ name: 'Preparing for upload ...', type: 'unknown' } as FileWithId));
    }
  }, [uploadCancelled]);

  return (
    <Wrapper className="add-link-component">
      <h4 className="add-link-text">Add Link</h4>
      <Input
        placeholder="https://"
        className="input-for-add-link"
        onChange={onChange}
        value={input}
      />
      <GlobalButton
        title="Add Link"
        PaddingSm="5px 10px"
        innerSpace="9px 10px"
        bgColor={primaryColor}
        textColor="#fff"
        buttonClassName={classNames('add-link-cls', { disabled: !isInputValidated() })}
        onButtonClick={handleButtonClick}
      />
    </Wrapper>
  );
};

export default AddLinkComponent;
